export const REQUEST_BREACH_SUMMARY = "REQUEST_BREACH_SUMMARY";
export const REQUEST_SERVICE_CATALOG = "REQUEST_SERVICE_CATALOG";
export const RECEIVE_SERVICE_CATALOG = "RECEIVE_SERVICE_CATALOG";
export const RECEIVE_BREACH_SUMMARY = "RECEIVE_BREACH_SUMMARY";

export interface IBreachService {
    isBreachClarityInCatalog: boolean;
    isBreachClarityServiceActive: boolean;
}
export interface IBreachDetail {
    breachId: number;
    organizationName: string;
}
export interface IDetectedBreachSummary {
    newDetectedBreachCount?: number;
    newDetectedBreachList?: IBreachDetail[];
}
export interface IBreachSummaryState {
    customerBreachScore: number;
    actionToDoSummary: {
        openActionCount?: number;
    };
    detectedBreachSummary: IDetectedBreachSummary;
    isSuccess: boolean;
}
export interface IBreachState {
    isLoading: boolean;
    breachSummaryData: any;
}
export interface IBreachServiceState {
    isLoading: boolean;
    breachService: any;
}

export interface IRequestBreachSummaryAction {
    type: typeof REQUEST_BREACH_SUMMARY;
}
export interface IRequestServiceAndCatalog {
    type: typeof REQUEST_SERVICE_CATALOG;
}

export interface IReceiveServiceAndCatalog {
    type: typeof RECEIVE_SERVICE_CATALOG;
    breachService: any;
}
export interface IReceiveBreachSummaryAction {
    type: typeof RECEIVE_BREACH_SUMMARY;
    breachSummaryData: any;
}

export type BreachSummaryTypes = IRequestBreachSummaryAction | IReceiveBreachSummaryAction;

export type BreachServiceAndCatalogTypes = IRequestServiceAndCatalog | IReceiveServiceAndCatalog;
